/**
 * @file The Component contains the input for registering as a service section
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import React from 'react';

import { Divider, Form, Input, Row, Col, Checkbox } from 'antd';
//data & funcs
import { setFormFieldValue } from '../../../../Utils/utils';
import { LIN_REMOTEREPOSITORY } from '../../../../Utils/Constants';
import { getPageObjectByName } from '../../../../Utils/PageObjectsMapUtil';
//components
import Navigation from '../../../Navigation/Navigation';
import ButtonBar from '../../../ButtonBar/MainButtonBar/MainButtonBar';
import ReferencePicture from '../../../ReferencePicture/ReferencePicture';
//css
import 'antd/dist/antd.css';
import '../../../../Utils/CommonCss.css';

const PAGE_NAME = LIN_REMOTEREPOSITORY;

class RemoteRepository extends React.Component {
    constructor(props) {
        super(props);
        this.formSections = getPageObjectByName(PAGE_NAME).formSections;
    }
    nextStep = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.nextStep();
            }
        });
    };

    backStep = () => {
        this.props.backStep();
    };

    componentDidMount() {
        for (let formInfo of this.formSections.remoteRepoConfig) {
            setFormFieldValue(formInfo.fieldName, formInfo.state, this.props);
        }
    }

    /**
     *
     * Generate a list of form JSX item based on given data
     * @param {Array} formInfo an array that contains necessary content for each form item
     * @return {Array} an array of form items that contain input boxes
     */
    generateFormContent = (formInfo) => {
        const { getFieldDecorator } = this.props.form;
        return formInfo.map((section, index) => (
            <Form.Item
                label={section.label}
                key={index}
                className={section.fieldName}
            >
                {getFieldDecorator(section.fieldName, {
                    rules: [
                        {
                            required: section.rules[0].required,
                            message: section.rules[0].message,
                            whitespace: section.rules[0].whitespace,
                            pattern: section.rules[0].pattern,
                        },
                    ],
                })(
                    section.passwd ? (
                        <Input.Password
                            onChange={(e) => {
                                this.props.setOriginState(
                                    section.state,
                                    e.target.value
                                );
                            }}
                        />
                    ) : (
                        <Input
                            onChange={(e) => {
                                this.props.setOriginState(
                                    section.state,
                                    e.target.value
                                );
                            }}
                        />
                    )
                )}
            </Form.Item>
        ));
    };

    render() {
        let paOverrideCheckbox = null;
        let collabOverrideCheckbox = null;
        let storageOverrideCheckbox = null;
        let remoteConfigContent = null;
        if (this.props.getOriginState('platformAnalyticsActive')) {
            paOverrideCheckbox = (
                <Checkbox
                    onChange={(e) => {
                        this.props.setOriginState(
                            'platformAnalyticsOverrideDb',
                            e.target.checked
                        );
                    }}
                    checked={this.props.getOriginState(
                        'platformAnalyticsOverrideDb'
                    )}
                >
                    Override Platform Analytics Database if exists
                </Checkbox>
            );
        }

        if (this.props.getOriginState('collaborationActive')) {
            collabOverrideCheckbox = (
                <Checkbox
                    onChange={(e) => {
                        this.props.setOriginState(
                            'collaborationOverrideDb',
                            e.target.checked
                        );
                    }}
                    checked={this.props.getOriginState(
                        'collaborationOverrideDb'
                    )}
                >
                    Override Collaboration Database if exists
                </Checkbox>
            );
        }

        if (this.props.getOriginState('storageServiceActive')) {
            storageOverrideCheckbox = (
                <Checkbox
                    onChange={(e) => {
                        this.props.setOriginState(
                            'storageServiceOverrideDb',
                            e.target.checked
                        );
                    }}
                    checked={this.props.getOriginState(
                        'storageServiceOverrideDb'
                    )}
                >
                    Override Storage Service Database if exists
                </Checkbox>
            );
        }

        if (!this.props.getOriginState('repositoryActive')) {
            remoteConfigContent = (
                <div>
                    <br />
                    <br />
                    <div className="info-tag">
                        <img
                            className="info-icon"
                            alt="info icon"
                            src={require('../../../../assets/Icons/info.svg').default}
                        />
                        To use a remote repository, provide the connectivity
                        information to be used.{' '}
                        <a
                            href="http://www2.microstrategy.com/producthelp/Current/InstallConfig/en-us/Content/remote_repository.htm"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Learn more.
                        </a>
                    </div>
                    {this.generateFormContent(
                        this.formSections.remoteRepoConfig
                    )}
                    {paOverrideCheckbox}
                    {collabOverrideCheckbox}
                    {storageOverrideCheckbox}
                </div>
            );
        }

        return (
            <Form className="form">
                <Row type="flex" align="top">
                    <Col
                        span={4}
                        className={['colNav', 'linRegServiceNavHeight'].join(
                            ' '
                        )}
                    >
                        <p className="headlineTop">Steps</p>
                        <Navigation
                            validateForm={
                                this.props.form.validateFieldsAndScroll
                            }
                            setOriginState={this.props.setOriginState}
                            getOriginState={this.props.getOriginState}
                            steps={this.props.steps}
                            deepestStep={this.props.deepestStep}
                            useOs={this.props.useOs}
                        />
                    </Col>

                    <Col span={12} className="colContent">
                        <p className="headlineTop">Remote Repository</p>
                        <Checkbox
                            onChange={(e) => {
                                this.props.setOriginState(
                                    'repositoryActive',
                                    e.target.checked
                                );
                            }}
                            checked={this.props.getOriginState(
                                'repositoryActive'
                            )}
                        >
                            Use MicroStrategy Repository
                        </Checkbox>

                        {remoteConfigContent}
                    </Col>

                    <Divider
                        className="divider"
                        type="vertical"
                        orientation="right"
                    />
                    <Col span={7} className="colPics">
                        <p className="headlineTop">Reference Pictures</p>
                        <ReferencePicture
                            getOriginState={this.props.getOriginState}
                            pageName={PAGE_NAME}
                            useVersion={this.props.useVersion}
                        />
                    </Col>
                </Row>
                <ButtonBar
                    useOs={this.props.useOs}
                    clickNext={this.nextStep}
                    clickBack={this.backStep}
                />
            </Form>
        );
    }
}

const RemoteRepositorySetting = Form.create({
    name: 'RemoteRepository',
})(RemoteRepository);

export default RemoteRepositorySetting;
